import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  clear() {
    const dateInput = this.element.querySelector("input[type='date']")
    if (dateInput) {
      dateInput.value = ""
    }
    this.formTarget.requestSubmit()
  }
}
